import React, { useEffect, useRef, useState } from 'react';
import { Card } from 'primereact/card';
import { useOutletContext } from 'react-router-dom';
import "./home.css";
import { BlockUI } from 'primereact/blockui';
import OngoingPlanList from './ongoingPlanList';
import HomeHeader from './homeHeader';
import CarePlanCard from './OverallTab/carePlanCard';
import TreatmentAreasCard from './OverallTab/treatmentAreasCard';
import MonthlyReport from './OverallTab/monthlyReport';
import CompletedPlans from './OverallTab/completedPlans';
import TopCards from './TodayTab/topCards';

const Home = () => {
    const { t }: any = useOutletContext();
    const { ongoingPlanListData }: any = useOutletContext();
    const { allOngoingPlanListData }: any = useOutletContext();
    const { blockOngoingPlanListData }: any = useOutletContext();
    const { blockOngoingPlanListDataForToday }: any = useOutletContext();

    const [planList, setPlanList] = useState<any>([]);
    const [planListCount, setPlanListCount] = useState<any>();

    const [homePageMode, setHomePageMode] = useState<any>(0);

    const containerRef = useRef<any>(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    const [filterModes, setFilterModes] = useState<any>({
        missed: 1,
        low: 1,
        average: 1,
        high: 1,
    });

    const [finishedPlansFilter, setFinishedPlansFilter] = useState(false);
    const [notStartedPlansFilter, setNotStartedPlansFilter] = useState(false);
    const [activeLast5DaysFilter, setActiveLast5DaysFilter] = useState(false);

    useEffect(() => {
        if (homePageMode === 0) {
            setFilterModes({
                missed: 1,
                low: 1,
                average: 1,
                high: 1,
            })
            setPlanList(ongoingPlanListData.planList);
            setPlanListCount(ongoingPlanListData.count);
        }
        else {
            setFinishedPlansFilter(false);
            setNotStartedPlansFilter(false);
            setActiveLast5DaysFilter(false);
            setPlanList(allOngoingPlanListData.planList);
            setPlanListCount(allOngoingPlanListData.count);
        }
    }, [homePageMode, ongoingPlanListData, allOngoingPlanListData]);

    useEffect(() => {
        if (homePageMode === 0) {
            if (ongoingPlanListData && ongoingPlanListData?.planList?.length > 0) {
                const filteredPlanList = ongoingPlanListData.planList.filter((plan: any) => {
                    const adherenceList = plan.exercisesAdheranceList;
                    if (!adherenceList || adherenceList.length === 0) return false;

                    const lastEntry = adherenceList[adherenceList.length - 1];
                    const status = lastEntry.averageSuccessStatus?.toLowerCase();

                    return filterModes[status] === 1;
                });

                setPlanList(filteredPlanList);
                setPlanListCount(filteredPlanList.length);
            }
        }
    }, [filterModes]);

    useEffect(() => {
        if (homePageMode === 1 && allOngoingPlanListData && allOngoingPlanListData?.planList?.length > 0) {
            let filteredPlanList = [...allOngoingPlanListData.planList];

            if (finishedPlansFilter) {
                filteredPlanList = filteredPlanList.filter((plan: any) => {
                    return new Date(plan.planDateEnd) < new Date();
                });
            }

            if (notStartedPlansFilter) {
                filteredPlanList = filteredPlanList.filter((plan: any) => {
                    return new Date(plan.planDateStart) > new Date();
                });
            }

            if (activeLast5DaysFilter) {
                filteredPlanList = filteredPlanList.filter((plan: any) => {
                    if (plan.exercisesAdheranceList.length < 5) {
                        return false;
                    }

                    for (let i = plan.exercisesAdheranceList.length - 5; i < plan.exercisesAdheranceList.length; i++) {
                        if (plan.exercisesAdheranceList[i].averageSuccessStatus === "Missed" ||
                            plan.exercisesAdheranceList[i].averageSuccessStatus === "Rest Day") {
                            return false;
                        }
                    }
                    return true;
                });
            }
            setPlanList(filteredPlanList);
            setPlanListCount(filteredPlanList.length);
        }
    }, [finishedPlansFilter, notStartedPlansFilter, activeLast5DaysFilter, homePageMode, allOngoingPlanListData]);

    return (
        <>
            <BlockUI
                blocked={blockOngoingPlanListData || blockOngoingPlanListDataForToday}
                style={{ backgroundColor: "transparent", borderRadius: "24px" }}
                template={
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <dotlottie-player
                            src="https://lottie.host/102dcba8-b9a9-447a-af8e-3e134e77ea0c/Esb1U6xLam.lottie"
                            background="transparent"
                            speed="1"
                            style={{ width: "3rem", height: "3rem" }}
                            loop
                            autoplay
                        />
                    </div>
                }
            >
                <div className='flex flex-column gap-4'>
                    <div className='homeCards'>
                        <HomeHeader
                            homePageMode={homePageMode}
                            setHomePageMode={setHomePageMode}
                            filterModes={filterModes}
                            setFilterModes={setFilterModes}
                            t={t}
                        />
                    </div>

                    {homePageMode === 0 &&
                        <>
                            <div className='flex flex-wrap lg:flex-nowrap  gap-4'>
                                <TopCards
                                    ongoingPlanListData={ongoingPlanListData}
                                    t={t}
                                />
                            </div>
                        </>}

                    {homePageMode === 1 &&
                        <div className='grid'>
                            <CarePlanCard t={t} />
                            <TreatmentAreasCard t={t} />
                            <MonthlyReport t={t} />
                            <CompletedPlans t={t} />
                        </div>
                    }

                    <div className='homeCards'>
                        <Card style={{ borderRadius: "24px", position: "relative" }} className=' dashboardTable'>
                            <OngoingPlanList
                                planList={planList}
                                planListCount={planListCount}
                                filterModes={filterModes}
                                setFilterModes={setFilterModes}
                                homePageMode={homePageMode}
                                finishedPlansFilter={finishedPlansFilter}
                                setFinishedPlansFilter={setFinishedPlansFilter}
                                notStartedPlansFilter={notStartedPlansFilter}
                                setNotStartedPlansFilter={setNotStartedPlansFilter}
                                activeLast5DaysFilter={activeLast5DaysFilter}
                                setActiveLast5DaysFilter={setActiveLast5DaysFilter}
                                t={t}
                            />
                        </Card>
                    </div>

                </div>


            </BlockUI>


        </>
    );
}

export default Home